import CallAPI from "../../utility/functions/getData";
import {
  setAlertWithTitle,
  setSpinnerLoading,
} from "../../utility/Redux/modal";
import dataToLocal from "../../utility/component/dataToLocal";
import deleteWholeDatabase from "../../utility/functions/deleteWholeDatabase";

export const GetPurchaseSummary = (data, token, dispatch, setPurchaseList) => {
  dispatch(setSpinnerLoading("Getting purchase summary"));
  deleteWholeDatabase("credit_note_report");
  CallAPI(
    "/api/creditNote/listCreditNote",
    data,
    token,
    (e) => {
      if (!e.data.error) {
        console.log(e);
        const res = e.data.response.data;
        if (res[0]) {
          setPurchaseList(res);
          dataToLocal("credit_note_report", res, [
            {
              ...data,
              ICODE: 1,
            },
          ]);
        } else {
          setPurchaseList([]);
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "No Records found",
            })
          );
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch,
    () => {
      dispatch(setSpinnerLoading(false));
    }
  );
};
